import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {WfControleComponent} from "./wf-controle.component";
import {CircuitsValidationComponent} from "./circuits-validation/circuits-validation.component";
import {DroitAdmin} from "@core/security/droit-admin";

export const workflowControleRoutes : Routes = [
    {
        path: 'CircuitsValidation',
        component: CircuitsValidationComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_CONTROLE_WORKFLOW] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'CircuitsValidation'
    }, {
        path: '**',
        redirectTo: 'CircuitsValidation'
    }
];

@NgModule({
    imports: [ShareModule],
    declarations: [
        WfControleComponent,
        CircuitsValidationComponent
    ],
    exports: [
        CircuitsValidationComponent
    ],
    providers: []
})
export class WfControleModule {}
